import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { NotifiactionsDTO } from '../_models/jobsAndTalents/jobsAndTalentsModels';
import { CommonService } from './app.common.service';
@Injectable({
  providedIn: 'root'
})
export class HeaderNotificationService {
  private updateHeaderNotificationCount = new Subject<boolean>();
  private isFDMQuickLinkNotificationCount = new Subject<boolean>();
  private bySecurityRoleChanged = new Subject<boolean>();
  constructor(public common: CommonService) {
  }
  UpdateHeaderNotificationCount(isUpdate: boolean) {

    this.updateHeaderNotificationCount.next(isUpdate);
  }
  HeaderNotificationCount(): Observable<any> {
    return this.updateHeaderNotificationCount.asObservable();
  }


  updateFDMQuickLinkNotificationCount(isUpdate: boolean) {

    this.isFDMQuickLinkNotificationCount.next(isUpdate);
  }
  GetFDMQuickLinkNotification(): Observable<any> {
    return this.isFDMQuickLinkNotificationCount.asObservable();
  }

  notifyOnSecurityRoleChanged() {
    this.bySecurityRoleChanged.next(true);
  }
  onSecurityRoleChanged(): Observable<any> {
    return this.bySecurityRoleChanged.asObservable();
  }

}
